import React from "react";
import { ArrowDownSVG, TickDoubleSVG } from "../../ChikaExportSvg/ChikaExportSvg";
import GanttComponent from "./GanttComponent";

const AccordionBox = ({ data, isOpen, toggleAccordion }) => {
  const STATUSES = [
    { key: "registered", label: "ثبت شده" },
    { key: "approved", label: "تایید شده" },
    { key: "completed", label: "تکمیل شده" },
    { key: "preparation", label: "آماده سازی" },
    { key: "ready", label: "بارگیری شده" },
    { key: "delivered", label: "تحویل داده" },
  ];

  const steps = STATUSES.map(({ key, label }) => ({
    key,
    label,
    date: data?.status?.[key],
    status: data?.color?.gray?.includes(key)
    ? "pending" // خاکستری
    : data?.color?.yellow === key
    ? "inProgress" // زرد
    : "done", // سبز
  }));

  return (
    <div className="accordion__box">
      <div className="accordion__header" onClick={toggleAccordion}>    
        <div className="header__top">
          <div className="info__container">
            <span>کد سفارش: {data?.order_code}</span>
            <span>کاربر ثبت کننده: {data?.user}</span>
            <span>مشتری: {data?.customer_name}</span>
          </div>
          <div
            className="accordion__arrow"
            style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
          >
            <ArrowDownSVG />
          </div>
        </div>
        <div className="wizard__container">
          {steps.map((s, i) => (
            <React.Fragment key={s.key}>
              <div className="wizard__step">
                <div className="wizard__icon">
                  <TickDoubleSVG color={s.status === "done" ? "#2EB872" : s.status === "inProgress" ? "#FFD62E" : "#BDBDBD"} />
                </div>
                <div className="wizard__label">{s.label}</div>
                {s.date && <div className="wizard__date">{s.date}</div>}
              </div>
              {i < steps.length - 1 && (
                <div className={`wizard__line ${["inProgress", "pending"].includes(s.status) ? "dashed" : ""}`} />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      {isOpen && (
        <div className="accordion__content">
          <GanttComponent data={data?.chart} />
        </div>
      )}
    </div>
  );
};

export default AccordionBox;
